import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { RegisterForm, RegisterFormData } from '../../components/auth/RegisterForm';
import { useAuth } from '../../components/auth/AuthContext';
export function CustomerRegister() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    login
  } = useAuth();
  // Check if there's a redirect parameter
  const searchParams = new URLSearchParams(location.search);
  const redirectFrom = searchParams.get('redirect');
  const handleRegister = (data: RegisterFormData) => {
    // In a real application, this would call an API endpoint
    console.log('Customer registration data:', data);
    // Simulate successful registration without authentication delay
    const userData = {
      type: 'customer',
      email: data.email,
      name: data.name
    };
    localStorage.setItem('user', JSON.stringify(userData));
    login(userData);
    // Directly navigate to dashboard
    if (redirectFrom === 'service-request') {
      // Get the pending service request from localStorage
      const pendingRequest = localStorage.getItem('pendingServiceRequest');
      if (pendingRequest) {
        // In a real app, you would submit this request to your backend
        console.log('Submitting service request:', JSON.parse(pendingRequest));
        localStorage.removeItem('pendingServiceRequest');
      }
      navigate('/customer/dashboard');
    } else {
      navigate('/customer');
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-622">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-623">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-624">
          Create a Customer Account
        </h2>
        {redirectFrom === 'service-request' && <p className="mt-2 text-center text-sm text-primary font-medium" data-id="element-625">
            Create an account to complete your service request
          </p>}
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-626">
          Or{' '}
          <Link to={redirectFrom === 'service-request' ? `/auth/customer-login?redirect=${redirectFrom}` : '/auth/customer-login'} className="font-medium text-primary hover:text-primary/80" data-id="element-627">
            sign in to your existing account
          </Link>
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-628">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-629">
          <RegisterForm userType="customer" onSubmit={handleRegister} data-id="element-630" />
          <div className="mt-6" data-id="element-631">
            <div className="relative" data-id="element-632">
              <div className="absolute inset-0 flex items-center" data-id="element-633">
                <div className="w-full border-t border-gray-300" data-id="element-634" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-635">
                <span className="px-2 bg-white text-gray-500" data-id="element-636">
                  Or continue with
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-637">
              <div data-id="element-638">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-639">
                  <span className="sr-only" data-id="element-640">Sign up with Google</span>
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-641">
                    <path d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 110-12.064 5.963 5.963 0 014.123 1.608l2.685-2.688A9.95 9.95 0 0012.545 2.001a10.003 10.003 0 000 20.005c5.552 0 9.455-4.009 9.455-9.648a9.032 9.032 0 00-.16-1.675h-9.295z" data-id="element-642" />
                  </svg>
                </a>
              </div>
              <div data-id="element-643">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-644">
                  <span className="sr-only" data-id="element-645">Sign up with Facebook</span>
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-646">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-647" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="mt-6 text-center" data-id="element-648">
            <Link to="/auth/vendor-register" className="font-medium text-primary hover:text-primary/80" data-id="element-649">
              Register as a vendor instead
            </Link>
          </div>
        </div>
      </div>
    </div>;
}